import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  FormOneColumnGeneric,
} from './styles';
import SubmitButton from './ConditionalSubmitButton';

import {
  GenericTextareaInput,
} from './FormInputs';
import { ReCaptchaControl } from '../../../../components/shared/forms';
import SpinnerLoading from '../../../../components/shared/layout/SpinnerLoading';
import { Section } from '../../../../components/shared/pages';
import SinistroSucesso from '../SinistroSucesso';
import { useCEP } from '../../../../hooks';
import Mensagens from './Mensagens';
import { SinisterContext } from '../../../../context/SinisterContext';

import {
  handleCepData,
  renderErrorMessage,
  useNomeEvento,
  getDocumento,
  getCausasOptions,
  getReclamanteCpfValue,
} from './utils';
import EventoDiagnosticoDoencaGrave from './EventoDiagnosticoDoencaGrave';
import {
  getLabelNome,
  getLabelCPF,
  getLabelDataNascimento,
  getSelectInputOptionsPessoa,
  getEventoMorteEisCausaAcidentalOuCausaNatural,
  getOptionsEvento,
} from './CondicionaisSinistro';

import {DadosSegurado, DadosReclamante, DadosSinistro} from './SinistroSections';

const FormularioSinistro = ({
  isLoadingSinistro,
  errorSinistro,
  exibirSucesso,
  numeroProtocolo,
  falhaFluxo,
  values: {
    segurado: {
      tipoPessoa,
      cnpjSegurado,
      razaoSocialSegurado,
      cpfSegurado,
      nomeSegurado,
      dthNascimentoSegurado,
      sexoSegurado,
    },
    reclamante: {
      grauParentesco,
      nomeReclamante,
      cpfReclamante,
      telefoneResidencial,
      telefoneCelular,
      email,
      emailValid,
      cep,
      endereco,
      cidade,
      bairro,
      complemento,
      numero,
      estado,
    },
    dadosSinistro: {
      evento,
      causa,
      pessoa,
      nomeConjugeFilho,
      cpfConjugeFilho,
      dthNascimentoConjugeFilho,
      dthSinistro,
      dthAcidente,
      historicoSinistro,
    },
  },
  handleBlur,
  handleChange,
  isValid,
  errors,
  dirty,
  touched,
  isSubmitting,
  setFieldValue,
  setFieldError,
  setValues,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const formikBag = {
    onBlur: handleBlur,
    onChange: handleChange,
    errors,
    isValid,
    dirty,
    touched,
    isSubmitting,
    setFieldValue,
    setFieldError,
    setValues,
  };
  const CEP_INPUT_NAME = 'reclamante.cep';

  const { getAddress, foundCep, data: dataCep, loading: loadingCep } = useCEP();

  const setValuesCep = (dataCEP) => (prevState) => ({
    ...prevState,
    reclamante: {
      ...prevState.reclamante,
      endereco: dataCEP?.dados.INDTPLOG ?? '',
      estado: dataCEP?.dados.CODUF ?? '',
      cidade: dataCEP?.dados.NOMLOC ?? '',
      bairro: dataCEP?.dados.NOMEBAIR ?? '',
    },
  });

  const ND = 'Não Disparar';
  const tipoPessoaFisica = 'PessoaFisica';
  const tipoPessoaJuridica = 'PessoaJuridica';

  const eventoAfastamentoMedico = 'AfastamentoMedico';
  const eventoDiariaInternacao = 'DiariaInternacao';
  const eventoDiagnosticoDoencaGrave = 'DiagnosticoDoencaGrave';
  const eventoInvalidez = 'Invalidez';
  const eventoPerdaEmprego = 'PerdaEmprego';
  const eventoReembolso = 'Reembolso';

  const causaAcidental = 'Acidental';
  const causaQuebraOsso = 'QuebraOsso';
  const causaProcedimentoCirurgico = 'ProcedimentoCirurgico';
  const causaCuidadoDomiciliar = 'CuidadoDomiciliar';
  const causaDoenca = 'Doenca';
  const causaNatural = 'Natural';

  const pessoaConjuge = 'Conjuge';
  const pessoaFilho = 'Filho';
  const pessoaTitular = 'Titular';
  const messageErro = 'Erro: Preencher campos obrigatórios.';

  const [documento, setDocumento] = useState(ND);
  const [isTooltipe, setIsTooltipe] = useState(false);
  const { exibirSemProduto } = useContext(SinisterContext);

  const ShowTooltip = () => {
    setIsTooltipe(evento === 'Gravidez');
  };
  const {
    eventoGravidez,
    isEventoMorte,
    isCausaAcidentalOuCausaNatural,
  } = useNomeEvento(
    pessoa,
    evento,
    causa,
    nomeConjugeFilho,
    cpfConjugeFilho,
    dthNascimentoConjugeFilho
  );

  const isTipoPessoaPessoaFisica = tipoPessoa === tipoPessoaFisica;
  const isTipoPessoaPessoaJuridica = tipoPessoa === tipoPessoaJuridica;

  const isGrauParentescoPessoaTitular = grauParentesco === pessoaTitular;

  const isEventoGravidez = evento === eventoGravidez;
  const isEventoInvalidezAfastamentoMedicoDiariaInternacao = [
    eventoInvalidez,
    eventoAfastamentoMedico,
    eventoDiariaInternacao,
  ].includes(evento);

  const isEventoDiagnosticoDoencaGravePerdaEmpregoReembolsoGravidez = [
    eventoDiagnosticoDoencaGrave,
    eventoPerdaEmprego,
    eventoReembolso,
    eventoGravidez,
  ].includes(evento);

  const isPessoaFilho = pessoa === pessoaFilho;

  const isPessoaConjugeOuFilho = [pessoaConjuge, pessoaFilho].includes(pessoa);
  const isCausaNatural = causa === causaNatural;
  const isCausaAcidentall = causa === causaAcidental;
  const isCausaQuebraOsso = causa === causaQuebraOsso;
  const isCausaDoenca = causa === causaDoenca;
  const isCausaProcedimentoCirurgico = causa === causaProcedimentoCirurgico;
  const isCausaCuidadoDomiciliar= causa === causaCuidadoDomiciliar;

  const isEventoMorteEisCausaAcidentalOuCausaNatural = getEventoMorteEisCausaAcidentalOuCausaNatural(
    isEventoMorte,
    isCausaAcidentalOuCausaNatural
  );

  const optionsEvento = getOptionsEvento(isTipoPessoaPessoaFisica);

  const optionCausa = getCausasOptions(isTipoPessoaPessoaFisica, evento);

  const ValueReclamanteCpf = getReclamanteCpfValue(
    isGrauParentescoPessoaTitular,
    cpfSegurado,
    cpfReclamante
  );

  const labelNome = getLabelNome(isPessoaFilho);
  const LabelCPF = getLabelCPF(isPessoaFilho);
  const LabelDataNascimento = getLabelDataNascimento(isPessoaFilho);
  const selectInputOptionsPessoa = getSelectInputOptionsPessoa(
    isTipoPessoaPessoaFisica,
    isEventoMorteEisCausaAcidentalOuCausaNatural,
    isTipoPessoaPessoaJuridica
  );

  useEffect(() => {
    const doc = getDocumento(tipoPessoa, evento, causa, pessoa);
    setDocumento(doc);
    ShowTooltip();
  }, [tipoPessoa, evento, causa, pessoa]);

  useEffect(() => {
    handleCepData(
      loadingCep,
      dataCep,
      foundCep,
      setValues,
      setValuesCep,
      formikBag,
      CEP_INPUT_NAME
    );
  }, [loadingCep, dataCep]);

  return (
    <>
      <SpinnerLoading isLoading={isLoadingSinistro} />
      {exibirSucesso && (
        <Section
          id="sinistro-abertura-sucesso"
          as={SinistroSucesso}
          title=""
          sectionLayout={null}
          protocolo={numeroProtocolo}
          documento={documento}
        />
      )}
      {!exibirSucesso && (
        <>
          
          

         
       
          <DadosSegurado
            tipoPessoa={tipoPessoa}
            cnpjSegurado={cnpjSegurado}
            razaoSocialSegurado= {razaoSocialSegurado}
            cpfSegurado={cpfSegurado}
            nomeSegurado={nomeSegurado}
            dthNascimentoSegurado={dthNascimentoSegurado}
            sexoSegurado={sexoSegurado}
            formikBag={formikBag}
          />
           
          <DadosReclamante
          
            grauParentesco={grauParentesco}
            nomeReclamante={nomeReclamante}
            telefoneResidencial={telefoneResidencial}
            telefoneCelular= {telefoneCelular}
            email={email}
            emailValid={emailValid}
            cep={cep}
            endereco={endereco}
            cidade={cidade}
            bairro={bairro}
            complemento={complemento}
            numero={numero}
            estado={estado}
            formikBag={formikBag}
            isGrauParentescoPessoaTitular={isGrauParentescoPessoaTitular}
            nomeSegurado={nomeSegurado}
            ValueReclamanteCpf={ValueReclamanteCpf}
            CEP_INPUT_NAME= {CEP_INPUT_NAME}
            getAddress={getAddress} 
          />

          <DadosSinistro
            evento={evento}
            causa={causa}
            pessoa={pessoa}
            nomeConjugeFilho={nomeConjugeFilho}
            cpfConjugeFilho={cpfConjugeFilho}
            dthNascimentoConjugeFilho={dthNascimentoConjugeFilho}
            dthSinistro={dthSinistro}
            dthAcidente={dthAcidente}
            formikBag={formikBag}
            isTooltipe={isTooltipe}
            optionsEvento={optionsEvento}
            optionCausa={optionCausa}
            isEventoMorte={isEventoMorte}
            isPessoaConjugeOuFilho={isPessoaConjugeOuFilho}
            labelNome={labelNome}
            LabelCPF={LabelCPF}
            LabelDataNascimento={LabelDataNascimento}
            selectInputOptionsPessoa={selectInputOptionsPessoa}
            isEventoInvalidezAfastamentoMedicoDiariaInternacao={
              isEventoInvalidezAfastamentoMedicoDiariaInternacao}
            isCausaAcidentall={isCausaAcidentall}
            isCausaQuebraOsso={isCausaQuebraOsso}
            isCausaDoenca={isCausaDoenca}
            isCausaNaturalQuebraOsso={isCausaNatural}
            isCausaNatural={isCausaNatural}
            isCausaCuidadoDomiciliar={isCausaCuidadoDomiciliar}
            isCausaProcedimentoCirurgico={isCausaProcedimentoCirurgico}
          />

          {/* DIAGNÓSTICO DE DOENÇA GRAVE */}
          <EventoDiagnosticoDoencaGrave
            isEventoDiagnosticoDoencaGravePerdaEmpregoReembolsoGravidez={
              isEventoDiagnosticoDoencaGravePerdaEmpregoReembolsoGravidez
            }
            isEventoGravidez={isEventoGravidez}
            dthSinistro={dthSinistro}
            formikBag={formikBag}
          />

          <FormOneColumnGeneric>
            <GenericTextareaInput
              controlId="formSinistro.dadosSinistro.historicoSinistro"
              name="dadosSinistro.historicoSinistro"
              label="Histórico do sinistro (BREVE RELATO) *"
              placeholder="Por favor, escreva um resumo do que aconteceu."
              value={historicoSinistro}
              rows="10"
              formikBag={formikBag}
            />
          </FormOneColumnGeneric>

          <div id="recaptcha">
            <ReCaptchaControl
              size="normal"
              label="ReCaptcha *"
              {...formikBag}
            />
          </div>
          {renderErrorMessage(errors, touched, errors.reCaptcha)}

          <MarginBase />
          <SubmitButton
            isLoading={isLoadingSinistro}
            label="Abrir comunicado de sinistro"
            exibirSemProduto={exibirSemProduto}
            falhaFluxo={falhaFluxo}
            formikBag={formikBag}
          />

          {renderErrorMessage(errors, touched, messageErro)}
          <SpinnerLoading isLoading={isSubmitting} />
        </>
      )}
      <Mensagens
        errorSinistro={errorSinistro}
        exibirSemProduto={exibirSemProduto}
      />

      <MarginTop />
    </>
  );
};

FormularioSinistro.defaultProps = {
  errorSinistro: false,
  isLoadingSinistro: false,
  exibirSucesso: false,
  numeroProtocolo: '',
  falhaFluxo: false,
};

FormularioSinistro.propTypes = {
  values: PropTypes.objectOf(Object).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.objectOf(Array).isRequired,
  dirty: PropTypes.bool.isRequired,
  touched: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isLoadingSinistro: PropTypes.bool,
  errorSinistro: PropTypes.bool,
  exibirSucesso: PropTypes.bool,
  numeroProtocolo: PropTypes.number,
  falhaFluxo: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
};

const MarginTop = styled.div`
  margin-top: 50px;
`;
const MarginBase = styled.div`
  margin-top: 20px;
`;

export default FormularioSinistro;
